/**
 * Theme Constants
 * Shared constants used across all themes
 */

// Color constants for theme icons (consistent across all themes)
export const ICON_COLORS = {
  lightIconBg: '#FFFFFF',
  lightIconColor: '#1e293b',
  darkIconBg: '#1e293b',
  darkIconColor: '#FFFFFF',
}

